import { Mail, Phone } from 'lucide-react';

import { Container } from '../components/Container';
import { SectionHeading } from '../components/SectionHeading';
import { ContactForm } from '../features/contact/ContactForm';
import { site } from '../content/shared';
import type { LandingContent } from '../content/types';
import { sectionIds } from '../lib/routes';

type ContactSectionProps = {
  content: LandingContent;
};

export function ContactSection({ content }: ContactSectionProps) {
  return (
    <section className="section contact-section" id={sectionIds.contact} aria-labelledby="contact-title">
      <Container className="contact-section__grid">
        <div>
          <SectionHeading id="contact-title" title={content.contact.h2} intro={content.contact.intro} />
          <div className="direct-contact" aria-label={content.contact.directTitle}>
            <a href={`mailto:${site.email}`}>
              <Mail aria-hidden="true" size={18} />
              <span>{site.email}</span>
            </a>
            <a href={`tel:${site.phoneSchema}`}>
              <Phone aria-hidden="true" size={18} />
              <span>{site.phoneDisplay}</span>
            </a>
          </div>
        </div>
        <ContactForm content={content.contact} locale={content.locale} />
      </Container>
    </section>
  );
}
